{
  "title": "الأسعار والإعدادات",
  "description": "الأسعار الافتراضية للعمليات وكلمة مرور إغلاق الشفت",
  "salePrices": "أسعار البيع",
  "purchasePrices": "أسعار الشراء",
  "quantities": "الكميات",
  "security": "الأمان",
  "fields": {
    "dieselBarrelSalePrice": "سعر بيع برميل المحروقات",
    "dieselJerrycanSalePrice": "سعر بيع جركل المحروقات",
    "petrolBarrelSalePrice": "سعر بيع برميل البنزين",
    "petrolJerrycanSalePrice": "سعر بيع جركل البنزين",
    "dieselBarrelPurchasePrice": "سعر شراء برميل المحروقات",
    "dieselJerrycanPurchasePrice": "سعر شراء جركل المحروقات",
    "petrolBarrelPurchasePrice": "سعر شراء برميل البنزين",
    "petrolJerrycanPurchasePrice": "سعر شراء جركل البنزين",
    "jerrycansInBarrel": "عدد الجراكل في البرميل",
    "litersInJerrycan": "عدد اللترات في الجركل"
  },
  "informativeNote": "للعلم فقط، لا يدخل في الحسابات",
  "closePassword": {
    "label": "كلمة مرور إغلاق الشفت",
    "placeholder": "اتركه فارغا للإبقاء على كلمة المرور الحالية",
    "setHint": "تم تعيين كلمة مرور",
    "notSetHint": "لم يتم تعيين كلمة مرور"
  },
  "readOnlyNotice": "ليس لديك صلاحية تعديل الأسعار والإعدادات",
  "save": "حفظ",
  "confirm": {
    "title": "حفظ التغييرات على الأسعار والإعدادات؟",
    "description": "سيتم تطبيق الأسعار الجديدة على العمليات القادمة فورا.",
    "changedPricesTitle": "الأسعار التي تغيرت:",
    "closePasswordChanged": "سيتم تغيير كلمة مرور إغلاق الشفت.",
    "noChanges": "لا توجد تغييرات على الأسعار.",
    "confirmLabel": "حفظ",
    "overviewPasswordChanged": "سيتم تغيير كلمة مرور لمحة عامة."
  },
  "discard": {
    "title": "تجاهل التغييرات؟",
    "description": "لن يتم حفظ التغييرات التي أدخلتها على الأسعار والإعدادات.",
    "confirmLabel": "تجاهل",
    "cancelLabel": "متابعة التعديل"
  },
  "toasts": {
    "saved": "تم تحديث الأسعار والإعدادات بنجاح"
  },
  "validation": {
    "mustBePositive": "يجب أن تكون القيمة أكبر من صفر",
    "tooManyDecimals": "يسمح بخمس منازل عشرية كحد أقصى.",
    "passwordTooShort": "كلمة المرور يجب ألا تقل عن 4 أحرف"
  },
  "overviewPassword": {
    "label": "كلمة مرور لمحة عامة",
    "placeholder": "اتركه فارغا للإبقاء على كلمة المرور الحالية",
    "setHint": "تم تعيين كلمة مرور",
    "notSetHint": "لم يتم تعيين كلمة مرور"
  },
  "phoneVerification": {
    "label": "تأكيد رقم الهاتف برمز واتساب",
    "help": "يرسل رمز عبر واتساب عند إضافة عميل أو تغيير رقم الهاتف",
    "on": "مفعل",
    "off": "غير مفعل",
    "helpSave": "ولا يتم الحفظ إلا بعد إدخال الرمز"
  }
}
